<template>
  <div style="color: #ffffff">
    <img
      width="100%"
      style="min-height:17em;object-fit:cover;"
      :src="require('@/assets/images/aboutus.png')"
    />
    <div
      style="position: absolute; color: black; background-color: white;"
      :style="
        bigScreen
          ? 'margin: 0% 10%; top: 55%;width:80%'
          : 'top: 40%; width: 100%'
      "
    >
      <div
        data-aos="fade-up"
        data-aos-duration="2000"
        data-aos-anchor-placement="center-bottom"
        style="margin: 5% 3%"
      >
        <h1 :style="'font-size:' + size + 'em;'" class="bold">
          Who are we?
        </h1>
        <v-divider style="background-color: #26BFC9; width: 25%;"></v-divider>
        <br /><br v-if="bigScreen" />
        <p :style="'font-size:' + size2 + 'em;'">
          We are students from Tecnico University that are doing the master's
          degree in Information Systems and Computer Engineering. This is our
          website for the CCU course, where we show our progresss during the
          development of our project. Hope you enjoy.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs1",
  data() {
    return {
      bigScreen: true,
      size: 5,
      size2: 2,
      size3: 3
    };
  },
  methods: {
    update() {
      window.innerWidth > 1000
        ? (this.bigScreen = true)
        : (this.bigScreen = false);
      var height = (window.innerWidth * 9) / 12;
      var ems = height / 20;
      this.size = ems / 20;
      this.size2 = 0.5 * this.size;
      this.size3 = 0.6 * this.size;
      if (this.size < 1.3) {
        this.size = 1.3;
        this.size2 = 1.2;
        this.size3 = 1.3;
      }
    }
  },
  mounted() {
    this.update();
    this.$options.interval = setInterval(this.update, 500);
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #ffffff;
}

.bold {
  font-weight: bold;
}
</style>
